import { useQuery } from '@tanstack/react-query';
import { useTranslate } from '@tolgee/react';
import { HomePageApiResponse } from 'abi-lcm-common-types';

import { useToast } from '~/app/contexts/ToastContext';
import { lcmApi } from '~/shared/services/api';

import { GET_PROCESS_INFO_QUERY_KEY } from './queryKeys';

export async function getProcessInfo(
  version?: 'v2',
  token?: string
): Promise<HomePageApiResponse> {
  let endpoint = '/home-page/info';

  if (version === 'v2') {
    endpoint = endpoint.replace('/info', '/v2/info');
  }
  const { data } = await lcmApi.get<HomePageApiResponse>(endpoint, {
    ...(token && {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),
  });

  return data;
}

export function useGetProcessInfo(version?: 'v2') {
  const { t } = useTranslate('home');
  const toast = useToast();

  return useQuery({
    queryKey: [GET_PROCESS_INFO_QUERY_KEY, version],
    queryFn: () => getProcessInfo(version),
    onError: () => {
      toast.add({
        type: 'error',
        description: t('home-page.error-get-process-info'),
      });
    },
  });
}
